enum GesCloudOrgSettingsPage {
	ORGANIZATION = "organization",
	MEMBERS = "members",
	TOKENS = "tokens",
}

export default GesCloudOrgSettingsPage;
